import React from "react";
import "./Button.scss";
interface Buttonprops {
  text: string;
  onClick: () => void;
  isPrimary: boolean;
  isBorder?: boolean;
  isDisable?: boolean;
  isLoading?: boolean;
}
const Button: React.FC<Buttonprops> = ({
  text,
  onClick,
  isPrimary,
  isBorder,
  isDisable,
  isLoading,
}) => {
  return (
    <div
      onClick={onClick}
      className={`wr-button ${
        isDisable
          ? "wr-btm-disable "
          : isPrimary
          ? "wr-btm-primary"
          : isBorder
          ? "wr-btm-border"
          : "wr-btm-secondary"
      }`}
    >
      {isLoading ? <div className='loading-ic' /> : text}
    </div>
  );
};
export default Button;
